function ProductService(ApiService) {
  'ngInject' ;
  const service = {};

  service.getData = function(orgId, url, pageNumber,size, callbackFunc) {
    ApiService.get(url, callbackFunc);
  };

 service.getProductCost = function(orgId, id, callbackFunc) {
   ApiService.get(`/organizations/${orgId}/product_costs/${id}.json`, callbackFunc);
 };

 service.editProductCost = function(productCostForm, orgId, id, callbackFunc) {
   ApiService.put(`/organizations/${orgId}/product_costs/${id}.json`, productCostForm, callbackFunc);
 };

 service.deleteProductCost = function(orgId, id, callbackFunc) {
   ApiService.delete(`/organizations/${orgId}/product_costs/${id}.json`, {}, callbackFunc);
 };

  service.saveFile = function(productFileForm, orgId, callbackFunc) {
    ApiService.saveFile(`/organizations/${orgId}/product_costs/import.json`, productFileForm, callbackFunc);
  };

  service.saveProductCost = function(productCostForm, orgId, callbackFunc) {
    ApiService.post(`/organizations/${orgId}/product_costs.json`, productCostForm, callbackFunc);
  };

  service.deleteAllProductCosts = function(orgId, callbackFunc) {
    ApiService.delete(`/organizations/${orgId}/product_costs/delete_all_costs.json`, {}, callbackFunc);
  };

  return service;
}

export default{
  name: 'ProductService',
  fn: ProductService
};
